
// Import module styles.
import "./flashMessage.view.less";

// Define controllers.
window.owvqva = {
	FlashMessage
};

function FlashMessage() {

	return {
		init: init
	};

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I initialize the component.
	*/
	function init() {

		// In order to make sure that the page doesn't continue to show the flash message
		// on navigation (back/forward/refresh), we're going to replace the current item
		// on the history stack.
		var url = new URL( window.location.href );
		url.searchParams.delete( "flash" );
		url.searchParams.delete( "flashData" );

		window.history.replaceState( {}, "", url );

		// Focus the flash message as well.
		this.$el.focus();

	}

}
